import { render } from "./aml_verification.html?vue&type=template&id=4abca3a3&external"
import script from "./aml_verification.js?vue&type=script&lang=js&external"
export * from "./aml_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__